module.exports = __webpack_public_path__ + "media/images/flags/ir-12e7432b428f8d631eb5fede40b2e095.svg";